import { SelectProps } from '@mantine/core';
import { useTranslation } from 'next-i18next';
import { useCallback } from 'react';

import { ActivityThemeStyles } from 'shared/types/Theme';

import { Select } from '@/components/Select';
import { ResetButton } from '@/components/Theme/ResetButton';
import { TooltipConfigProps } from '@/utils/tiptap/extensions/Tooltip/components/TooltipConfig';
import { TOOLTIP_POSITION } from '@/utils/tiptap/extensions/Tooltip/utils/tooltipUtils';
import { FormControl } from '@/widgets/_components/FormControl';

export function Position(props: TooltipConfigProps) {
  const { styles, onRemoveStyle, resolvedStyles, onUpdateStyle } = props;
  const { t } = useTranslation('components', { keyPrefix: 'theme.settings' });

  const setPosition = useCallback(
    (newPosition: ActivityThemeStyles['tooltip']['position']) => onUpdateStyle({ position: newPosition }),
    [onUpdateStyle]
  );

  return (
    <FormControl title={t('position')}>
      <Select
        data={TOOLTIP_POSITION}
        value={resolvedStyles.position}
        onChange={setPosition as SelectProps['onChange']}
      />
      {styles.position && <ResetButton onClick={() => onRemoveStyle('position')} />}
    </FormControl>
  );
}
